/* Edits the state whenever siteId is changed */

export default function openedFolder(state = [], action) {
	switch (action.type) {
	case 'FILE_OPEN':
		return action.file;

	default:
		return state;
	}
}
